export default "__VITE_ASSET__CfjbrCSA__"